import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLike, meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {UnaryMathOperatorParameters} from "#template/nodes/geometry-graph/attribute/unary-math-operator/geometry-unary-math-operator-node"
import {
    GeometryUnaryMathOperatorNode,
    unaryMathOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute/unary-math-operator/geometry-unary-math-operator-node"

export type MeshGeometryUnaryMathOperatorParameters = UnaryMathOperatorParameters<MeshGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryUnaryMathOperatorParameters> = {
    nodeClass: "MeshGeometryUnaryMathOperator",
    validation: {
        parameters: unaryMathOperatorParametersSchema(meshGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryUnaryMathOperator extends GeometryUnaryMathOperatorNode<2, MeshGeometryAttributeLikeNode> implements MeshGeometryAttributeLikeNode {
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
